/**
 * TRILL API ADMIN
 * No description provided (generated by Swagger Codegen https://github.com/swagger-api/swagger-codegen)
 *
 * OpenAPI spec version: 1.1.75
 * 
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 *
 */


import ApiClient from "../ApiClient";
import ArticleAiAuditDetail from '../model/ArticleAiAuditDetail';
import ArticleAiAuditFeedbackDetail from '../model/ArticleAiAuditFeedbackDetail';
import ArticleAiAuditFeedbackUpdateValues from '../model/ArticleAiAuditFeedbackUpdateValues';
import ArticleAuditSummary from '../model/ArticleAuditSummary';
import ArticleSystemAuditDetail from '../model/ArticleSystemAuditDetail';
import ArticleUserAuditDetail from '../model/ArticleUserAuditDetail';
import ArticleUserAuditUpdateValues from '../model/ArticleUserAuditUpdateValues';
import NewArticleAiAuditFeedback from '../model/NewArticleAiAuditFeedback';
import NewArticleUserAudit from '../model/NewArticleUserAudit';

/**
* ArticleAudit service.
* @module api/ArticleAuditApi
* @version 1.1.75
*/
export default class ArticleAuditApi {

    /**
    * Constructs a new ArticleAuditApi. 
    * @alias module:api/ArticleAuditApi
    * @class
    * @param {module:ApiClient} [apiClient] Optional API client implementation to use,
    * default to {@link module:ApiClient#instance} if unspecified.
    */
    constructor(apiClient) {
        this.apiClient = apiClient || ApiClient.instance;
    }



    /**
     * 記事監査状況  レポート
     * @param {Object} opts Optional parameters
     * @param {Array.<String>} opts.filtering 絞り込みオプションの配列 （例：&#x60;publishDatetime &gt;&#x3D; &#39;2017-12-25T00:00:00Z&#39;&#x60;, &#x60;status &#x3D; &#39;publish&#39;&#x60;, &#x60;mediumId &lt;&gt; 7&#x60;） 
     * @return {Promise} a {@link https://www.promisejs.org/|Promise}, with an object containing data of type {@link module:model/ArticleAuditSummary} and HTTP response
     */
    getArticleAuditSummaryWithHttpInfo(opts) {
      opts = opts || {};
      let postBody = null;


      let pathParams = {
      };
      let queryParams = {
        'filtering': this.apiClient.buildCollectionParam(opts['filtering'], 'csv')
      };
      let headerParams = {
      };
      let formParams = {
      };

      let authNames = ['OAuth2'];
      let contentTypes = ['application/json', 'application/octet-stream'];
      let accepts = ['application/json', 'application/csv', 'text/plain'];
      let returnType = ArticleAuditSummary;

      return this.apiClient.callApi(
        '/articleAuditSummary', 'GET',
        pathParams, queryParams, headerParams, formParams, postBody,
        authNames, contentTypes, accepts, returnType
      );
    }

    /**
     * 記事監査状況  レポート
     * @param {Object} opts Optional parameters
     * @param {Array.<String>} opts.filtering 絞り込みオプションの配列 （例：&#x60;publishDatetime &gt;&#x3D; &#39;2017-12-25T00:00:00Z&#39;&#x60;, &#x60;status &#x3D; &#39;publish&#39;&#x60;, &#x60;mediumId &lt;&gt; 7&#x60;） 
     * @return {Promise} a {@link https://www.promisejs.org/|Promise}, with data of type {@link module:model/ArticleAuditSummary}
     */
    getArticleAuditSummary(opts) {
      return this.getArticleAuditSummaryWithHttpInfo(opts)
        .then(function(response_and_data) {
          return {
            statusCode: response_and_data.response.statusCode,
            header: response_and_data.response.header,
            data: response_and_data.data
          };
        });
    }


    /**
     * 提出された記事に対して AI 監査を再実行します。
     * @param {Number} articleId 記事の ID
     * @param {Number} aiAuditId 記事AI監査ID
     * @return {Promise} a {@link https://www.promisejs.org/|Promise}, with an object containing data of type {@link module:model/ArticleAiAuditDetail} and HTTP response
     */
    patchArticleAiAuditWithHttpInfo(articleId, aiAuditId) {
      let postBody = null;

      // verify the required parameter 'articleId' is set
      if (articleId === undefined || articleId === null) {
        throw new Error("Missing the required parameter 'articleId' when calling patchArticleAiAudit");
      }

      // verify the required parameter 'aiAuditId' is set
      if (aiAuditId === undefined || aiAuditId === null) {
        throw new Error("Missing the required parameter 'aiAuditId' when calling patchArticleAiAudit");
      }


      let pathParams = {
        'articleId': articleId,
        'aiAuditId': aiAuditId
      };
      let queryParams = {
      };
      let headerParams = {
      };
      let formParams = {
      };

      let authNames = ['OAuth2'];
      let contentTypes = ['application/json', 'application/octet-stream'];
      let accepts = ['application/json', 'application/csv', 'text/plain'];
      let returnType = ArticleAiAuditDetail;

      return this.apiClient.callApi(
        '/articles/{articleId}/aiAudits/{aiAuditId}', 'PATCH',
        pathParams, queryParams, headerParams, formParams, postBody,
        authNames, contentTypes, accepts, returnType
      );
    }

    /**
     * 提出された記事に対して AI 監査を再実行します。
     * @param {Number} articleId 記事の ID
     * @param {Number} aiAuditId 記事AI監査ID
     * @return {Promise} a {@link https://www.promisejs.org/|Promise}, with data of type {@link module:model/ArticleAiAuditDetail}
     */
    patchArticleAiAudit(articleId, aiAuditId) {
      return this.patchArticleAiAuditWithHttpInfo(articleId, aiAuditId)
        .then(function(response_and_data) {
          return {
            statusCode: response_and_data.response.statusCode,
            header: response_and_data.response.header,
            data: response_and_data.data
          };
        });
    }


    /**
     * 記事AI監査フィードバックの更新
     * @param {Number} articleAiAuditId 記事AI監査ID
     * @param {Number} feedbackId フィードバックID
     * @param {Object} opts Optional parameters
     * @param {module:model/ArticleAiAuditFeedbackUpdateValues} opts.articleAiAuditFeedbackUpdateValues 更新された記事 AI監査フィードバックコンテンツ
     * @return {Promise} a {@link https://www.promisejs.org/|Promise}, with an object containing data of type {@link module:model/ArticleAiAuditFeedbackDetail} and HTTP response
     */
    patchArticleAiAuditFeedbackWithHttpInfo(articleAiAuditId, feedbackId, opts) {
      opts = opts || {};
      let postBody = opts['articleAiAuditFeedbackUpdateValues'];

      // verify the required parameter 'articleAiAuditId' is set
      if (articleAiAuditId === undefined || articleAiAuditId === null) {
        throw new Error("Missing the required parameter 'articleAiAuditId' when calling patchArticleAiAuditFeedback");
      }

      // verify the required parameter 'feedbackId' is set
      if (feedbackId === undefined || feedbackId === null) {
        throw new Error("Missing the required parameter 'feedbackId' when calling patchArticleAiAuditFeedback");
      }


      let pathParams = {
        'articleAiAuditId': articleAiAuditId,
        'feedbackId': feedbackId
      };
      let queryParams = {
      };
      let headerParams = {
      };
      let formParams = {
      };

      let authNames = ['OAuth2'];
      let contentTypes = ['application/json', 'application/octet-stream'];
      let accepts = ['application/json', 'application/csv', 'text/plain'];
      let returnType = ArticleAiAuditFeedbackDetail;

      return this.apiClient.callApi(
        '/articleAiAudits/{articleAiAuditId}/feedbacks/{feedbackId}', 'PATCH',
        pathParams, queryParams, headerParams, formParams, postBody,
        authNames, contentTypes, accepts, returnType
      );
    }

    /**
     * 記事AI監査フィードバックの更新
     * @param {Number} articleAiAuditId 記事AI監査ID
     * @param {Number} feedbackId フィードバックID
     * @param {Object} opts Optional parameters
     * @param {module:model/ArticleAiAuditFeedbackUpdateValues} opts.articleAiAuditFeedbackUpdateValues 更新された記事 AI監査フィードバックコンテンツ
     * @return {Promise} a {@link https://www.promisejs.org/|Promise}, with data of type {@link module:model/ArticleAiAuditFeedbackDetail}
     */
    patchArticleAiAuditFeedback(articleAiAuditId, feedbackId, opts) {
      return this.patchArticleAiAuditFeedbackWithHttpInfo(articleAiAuditId, feedbackId, opts)
        .then(function(response_and_data) {
          return {
            statusCode: response_and_data.response.statusCode,
            header: response_and_data.response.header,
            data: response_and_data.data
          };
        });
    }


    /**
     * 校閲を実行
     * @param {Number} articleId 記事の ID
     * @param {Number} systemAuditId システム監査ID
     * @return {Promise} a {@link https://www.promisejs.org/|Promise}, with an object containing data of type {@link module:model/ArticleSystemAuditDetail} and HTTP response
     */
    patchArticleSystemAuditWithHttpInfo(articleId, systemAuditId) {
      let postBody = null;

      // verify the required parameter 'articleId' is set
      if (articleId === undefined || articleId === null) {
        throw new Error("Missing the required parameter 'articleId' when calling patchArticleSystemAudit");
      }

      // verify the required parameter 'systemAuditId' is set
      if (systemAuditId === undefined || systemAuditId === null) {
        throw new Error("Missing the required parameter 'systemAuditId' when calling patchArticleSystemAudit");
      }


      let pathParams = {
        'articleId': articleId,
        'systemAuditId': systemAuditId
      };
      let queryParams = {
      };
      let headerParams = {
      };
      let formParams = {
      };

      let authNames = ['OAuth2'];
      let contentTypes = ['application/json', 'application/octet-stream'];
      let accepts = ['application/json', 'application/csv', 'text/plain'];
      let returnType = ArticleSystemAuditDetail;

      return this.apiClient.callApi(
        '/articles/{articleId}/systemAudits/{systemAuditId}', 'PATCH',
        pathParams, queryParams, headerParams, formParams, postBody,
        authNames, contentTypes, accepts, returnType
      );
    }

    /**
     * 校閲を実行
     * @param {Number} articleId 記事の ID
     * @param {Number} systemAuditId システム監査ID
     * @return {Promise} a {@link https://www.promisejs.org/|Promise}, with data of type {@link module:model/ArticleSystemAuditDetail}
     */
    patchArticleSystemAudit(articleId, systemAuditId) {
      return this.patchArticleSystemAuditWithHttpInfo(articleId, systemAuditId)
        .then(function(response_and_data) {
          return {
            statusCode: response_and_data.response.statusCode,
            header: response_and_data.response.header,
            data: response_and_data.data
          };
        });
    }


    /**
     * 記事ユーザー監査の更新
     * @param {Number} articleId 記事の ID
     * @param {Number} userAuditId 記事ユーザー監査ID
     * @param {Object} opts Optional parameters
     * @param {module:model/ArticleUserAuditUpdateValues} opts.articleUserAuditUpdateValues 更新された記事 ユーザー監査コンテンツ
     * @return {Promise} a {@link https://www.promisejs.org/|Promise}, with an object containing data of type {@link module:model/ArticleUserAuditDetail} and HTTP response
     */
    patchArticleUserAuditWithHttpInfo(articleId, userAuditId, opts) {
      opts = opts || {};
      let postBody = opts['articleUserAuditUpdateValues'];

      // verify the required parameter 'articleId' is set
      if (articleId === undefined || articleId === null) {
        throw new Error("Missing the required parameter 'articleId' when calling patchArticleUserAudit");
      }

      // verify the required parameter 'userAuditId' is set
      if (userAuditId === undefined || userAuditId === null) {
        throw new Error("Missing the required parameter 'userAuditId' when calling patchArticleUserAudit");
      }


      let pathParams = {
        'articleId': articleId,
        'userAuditId': userAuditId
      };
      let queryParams = {
      };
      let headerParams = {
      };
      let formParams = {
      };

      let authNames = ['OAuth2'];
      let contentTypes = ['application/json', 'application/octet-stream'];
      let accepts = ['application/json', 'application/csv', 'text/plain'];
      let returnType = ArticleUserAuditDetail;

      return this.apiClient.callApi(
        '/articles/{articleId}/userAudits/{userAuditId}', 'PATCH',
        pathParams, queryParams, headerParams, formParams, postBody,
        authNames, contentTypes, accepts, returnType
      );
    }

    /**
     * 記事ユーザー監査の更新
     * @param {Number} articleId 記事の ID
     * @param {Number} userAuditId 記事ユーザー監査ID
     * @param {Object} opts Optional parameters
     * @param {module:model/ArticleUserAuditUpdateValues} opts.articleUserAuditUpdateValues 更新された記事 ユーザー監査コンテンツ
     * @return {Promise} a {@link https://www.promisejs.org/|Promise}, with data of type {@link module:model/ArticleUserAuditDetail}
     */
    patchArticleUserAudit(articleId, userAuditId, opts) {
      return this.patchArticleUserAuditWithHttpInfo(articleId, userAuditId, opts)
        .then(function(response_and_data) {
          return {
            statusCode: response_and_data.response.statusCode,
            header: response_and_data.response.header,
            data: response_and_data.data
          };
        });
    }


    /**
     * 記事のAI監査フィードバックを追加
     * @param {Number} articleAiAuditId 記事AI監査ID
     * @param {module:model/NewArticleAiAuditFeedback} newArticleAiAuditFeedback 記事AI監査フィードバックコンテンツを追加しました
     * @return {Promise} a {@link https://www.promisejs.org/|Promise}, with an object containing data of type {@link module:model/ArticleAiAuditFeedbackDetail} and HTTP response
     */
    postArticleAiAuditFeedbackWithHttpInfo(articleAiAuditId, newArticleAiAuditFeedback) {
      let postBody = newArticleAiAuditFeedback;

      // verify the required parameter 'articleAiAuditId' is set
      if (articleAiAuditId === undefined || articleAiAuditId === null) {
        throw new Error("Missing the required parameter 'articleAiAuditId' when calling postArticleAiAuditFeedback");
      }

      // verify the required parameter 'newArticleAiAuditFeedback' is set
      if (newArticleAiAuditFeedback === undefined || newArticleAiAuditFeedback === null) {
        throw new Error("Missing the required parameter 'newArticleAiAuditFeedback' when calling postArticleAiAuditFeedback");
      }


      let pathParams = {
        'articleAiAuditId': articleAiAuditId
      };
      let queryParams = {
      };
      let headerParams = {
      };
      let formParams = {
      };

      let authNames = ['OAuth2'];
      let contentTypes = ['application/json', 'application/octet-stream'];
      let accepts = ['application/json', 'application/csv', 'text/plain'];
      let returnType = ArticleAiAuditFeedbackDetail;

      return this.apiClient.callApi(
        '/articleAiAudits/{articleAiAuditId}/feedbacks', 'POST',
        pathParams, queryParams, headerParams, formParams, postBody,
        authNames, contentTypes, accepts, returnType
      );
    }

    /**
     * 記事のAI監査フィードバックを追加
     * @param {Number} articleAiAuditId 記事AI監査ID
     * @param {module:model/NewArticleAiAuditFeedback} newArticleAiAuditFeedback 記事AI監査フィードバックコンテンツを追加しました
     * @return {Promise} a {@link https://www.promisejs.org/|Promise}, with data of type {@link module:model/ArticleAiAuditFeedbackDetail}
     */
    postArticleAiAuditFeedback(articleAiAuditId, newArticleAiAuditFeedback) {
      return this.postArticleAiAuditFeedbackWithHttpInfo(articleAiAuditId, newArticleAiAuditFeedback)
        .then(function(response_and_data) {
          return {
            statusCode: response_and_data.response.statusCode,
            header: response_and_data.response.header,
            data: response_and_data.data
          };
        });
    }


    /**
     * 提出された記事に対してAIによる監査を実行します。
     * @param {Number} articleId 記事の ID
     * @return {Promise} a {@link https://www.promisejs.org/|Promise}, with an object containing data of type {@link module:model/ArticleAiAuditDetail} and HTTP response
     */
    postArticleAiAuditsWithHttpInfo(articleId) {
      let postBody = null;

      // verify the required parameter 'articleId' is set
      if (articleId === undefined || articleId === null) {
        throw new Error("Missing the required parameter 'articleId' when calling postArticleAiAudits");
      }


      let pathParams = {
        'articleId': articleId
      };
      let queryParams = {
      };
      let headerParams = {
      };
      let formParams = {
      };

      let authNames = ['OAuth2'];
      let contentTypes = ['application/json', 'application/octet-stream'];
      let accepts = ['application/json', 'application/csv', 'text/plain'];
      let returnType = ArticleAiAuditDetail;

      return this.apiClient.callApi(
        '/articles/{articleId}/aiAudits', 'POST',
        pathParams, queryParams, headerParams, formParams, postBody,
        authNames, contentTypes, accepts, returnType
      );
    }

    /**
     * 提出された記事に対してAIによる監査を実行します。
     * @param {Number} articleId 記事の ID
     * @return {Promise} a {@link https://www.promisejs.org/|Promise}, with data of type {@link module:model/ArticleAiAuditDetail}
     */
    postArticleAiAudits(articleId) {
      return this.postArticleAiAuditsWithHttpInfo(articleId)
        .then(function(response_and_data) {
          return {
            statusCode: response_and_data.response.statusCode,
            header: response_and_data.response.header,
            data: response_and_data.data
          };
        });
    }


    /**
     * 校閲を実行
     * @param {Number} articleId 記事の ID
     * @return {Promise} a {@link https://www.promisejs.org/|Promise}, with an object containing data of type {@link module:model/ArticleSystemAuditDetail} and HTTP response
     */
    postArticleSystemAuditsWithHttpInfo(articleId) {
      let postBody = null;

      // verify the required parameter 'articleId' is set
      if (articleId === undefined || articleId === null) {
        throw new Error("Missing the required parameter 'articleId' when calling postArticleSystemAudits");
      }


      let pathParams = {
        'articleId': articleId
      };
      let queryParams = {
      };
      let headerParams = {
      };
      let formParams = {
      };

      let authNames = ['OAuth2'];
      let contentTypes = ['application/json', 'application/octet-stream'];
      let accepts = ['application/json', 'application/csv', 'text/plain'];
      let returnType = ArticleSystemAuditDetail;

      return this.apiClient.callApi(
        '/articles/{articleId}/systemAudits', 'POST',
        pathParams, queryParams, headerParams, formParams, postBody,
        authNames, contentTypes, accepts, returnType
      );
    }

    /**
     * 校閲を実行
     * @param {Number} articleId 記事の ID
     * @return {Promise} a {@link https://www.promisejs.org/|Promise}, with data of type {@link module:model/ArticleSystemAuditDetail}
     */
    postArticleSystemAudits(articleId) {
      return this.postArticleSystemAuditsWithHttpInfo(articleId)
        .then(function(response_and_data) {
          return {
            statusCode: response_and_data.response.statusCode,
            header: response_and_data.response.header,
            data: response_and_data.data
          };
        });
    }


    /**
     * 記事ユーザー監査を追加する
     * @param {Number} articleId 記事の ID
     * @param {module:model/NewArticleUserAudit} newArticleUserAudit 追加される記事ユーザー監査の内容
     * @return {Promise} a {@link https://www.promisejs.org/|Promise}, with an object containing data of type {@link module:model/ArticleUserAuditDetail} and HTTP response
     */
    postArticleUserAuditWithHttpInfo(articleId, newArticleUserAudit) {
      let postBody = newArticleUserAudit;

      // verify the required parameter 'articleId' is set
      if (articleId === undefined || articleId === null) {
        throw new Error("Missing the required parameter 'articleId' when calling postArticleUserAudit");
      }

      // verify the required parameter 'newArticleUserAudit' is set
      if (newArticleUserAudit === undefined || newArticleUserAudit === null) {
        throw new Error("Missing the required parameter 'newArticleUserAudit' when calling postArticleUserAudit");
      }


      let pathParams = {
        'articleId': articleId
      };
      let queryParams = {
      };
      let headerParams = {
      };
      let formParams = {
      };

      let authNames = ['OAuth2'];
      let contentTypes = ['application/json', 'application/octet-stream'];
      let accepts = ['application/json', 'application/csv', 'text/plain'];
      let returnType = ArticleUserAuditDetail;

      return this.apiClient.callApi(
        '/articles/{articleId}/userAudits', 'POST',
        pathParams, queryParams, headerParams, formParams, postBody,
        authNames, contentTypes, accepts, returnType
      );
    }

    /**
     * 記事ユーザー監査を追加する
     * @param {Number} articleId 記事の ID
     * @param {module:model/NewArticleUserAudit} newArticleUserAudit 追加される記事ユーザー監査の内容
     * @return {Promise} a {@link https://www.promisejs.org/|Promise}, with data of type {@link module:model/ArticleUserAuditDetail}
     */
    postArticleUserAudit(articleId, newArticleUserAudit) {
      return this.postArticleUserAuditWithHttpInfo(articleId, newArticleUserAudit)
        .then(function(response_and_data) {
          return {
            statusCode: response_and_data.response.statusCode,
            header: response_and_data.response.header,
            data: response_and_data.data
          };
        });
    }


}
